import { SocialLogin } from '@capgo/capacitor-social-login';
import { useEffect } from 'react';
import { capacitorService } from '../../application/CapacitorService';
import { MobileAppBanner } from '../../components/MobileAppBanner';
import { AuthForm } from './AuthForm';
import { AuthContextProvider } from './context';

export const Auth = () => {
  // TODO: REVIEW IF THIS IS CALLED TWICE WHEN DOING A LOGOUT

  useEffect(() => {
    SocialLogin.initialize({
      google: {
        mode: `online`,
        // https://capgo.app/docs/plugins/social-login/google/web/
        webClientId: `1096635260173-tu1psbha32a854egiqn9g0pbfj7dtu9o.apps.googleusercontent.com`,
        iOSClientId: `1096635260173-dsbbkiutn07e1h51o3l8to1m30dqtvm7.apps.googleusercontent.com`,
      },
      ...(capacitorService.isIOS()
        ? {
            apple: {},
          }
        : {}),
      // apple: {
      //   // https://capgo.app/docs/plugins/social-login/apple/ios/
      //   clientId: `com.routal.drivers.auth`,
      // },
    });
  }, []); // Initialize SocialLogin only once

  return (
    <AuthContextProvider>
      <div style={{ width: `100%`, height: `100%` }}>
        <MobileAppBanner />
        <AuthForm />
      </div>
    </AuthContextProvider>
  );
};
